/** @jsx jsx */
import { jsx, css } from '@emotion/core' // eslint-disable-line
import React, { Component, useState, useEffect } from 'react' // eslint-disable-line

import { Drawer } from 'antd'

import { ViewerStyles, EditorStyles } from './business/styles'

interface Props {
  title: any
  content: any
  children?: any
  width?: any
  disabled?: boolean
}

export default (props: Props) => {
  const [visible, onVisibleChange] = useState(false)

  return (
    <div css={EditorStyles['edit-pane']}>
      <span onClick={
        () => {
          if (props.disabled) { return }
          onVisibleChange(true)
        }
      }>{props.content}</span>
      <Drawer
        title={props.title}
        width={props.width || 160}
        visible={visible}
        onClose={() => {
          onVisibleChange(false)
        }}
      >
        <div css={ViewerStyles['drawer-container']}>
          {props.children}
        </div>
      </Drawer>
    </div>
  )
}